import React from 'react';
import BanerArea from './Components/BanerArea';
import './Contact.css';
import ContactForm from './Components/ContactForm';

const Contact = () => {
  return (
    <div>
      <BanerArea />
      <ContactForm />
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4412.88563431701!2d72.83016587584436!3d21.184475682410934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e43933bcb8b%3A0x8033269b5a063654!2sEmpire%20State%20Building!5e1!3m2!1sen!2sin!4v1757400308275!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: '0' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Contact;